import { action } from 'easy-peasy';
import { IActionSetCarePlanIcd10Codes } from '../types';

const setCarePlanIcd10Codes: IActionSetCarePlanIcd10Codes = action((state, payload) => {
  state.items = payload;
});

export default setCarePlanIcd10Codes;
